export default __webpack_public_path__ + "static/media/newslide3.465fd900.jpg";